
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "DCOPD",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DCOPD.vue